import * as React from 'react';
import {useEffect, useState} from "react";
import { fetchMenuByUrl } from "../loaders.ts";
import type { MenuData } from "../rest.interface";
import Header from "./header.tsx";

interface Props {}

function HeaderLoader({...otherProps}: Props) {

	const [menu, setMenu] = useState<MenuData>(null);

	useEffect(() => {
		fetchMenuByUrl('main').then((data) => {
			setMenu(data);
		});
	}, []);

	return (<>
		<Header menu={menu} pathname={window.location.pathname} {...otherProps}/>
	</>);
}

export default HeaderLoader;
